export default "__VITE_ASSET__3b490d87__"